export const DEFAULT_AUCTION_COPY = {
    reserveMetLabel: 'Reserve Met',
    leadingStatusLabel: 'Currently Winning',
    outbidStatusLabel: 'Currently Losing',
    leadingHelperText: 'Increase your bid to maintain your lead',
    outbidHelperText: 'Place another bid to go back in front'
};
